import { AfterViewInit, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

import * as SimpleMDE from 'simplemde';

/**
 * Markdown text editor (single-line version). Usage:
 *
 * <app-markdown-editor-single-line [id]="'mytextfieldeditor'" [(content)]="myobj.mytextfield"></app-markdown-editor-single-line>
 */
@Component({
  selector: 'app-markdown-editor-single-line',
  templateUrl: './markdown-editor-single-line.component.html',
  styleUrls: ['./markdown-editor-single-line.component.css']
})
export class MarkdownEditorSingleLineComponent implements AfterViewInit, OnChanges {

  @Input()
  id: string;

  @Input()
  content: string;

  @Output()
  contentChange = new EventEmitter<string>();

  private markdownEditor: any = null;

  constructor() {}

  ngAfterViewInit() {
    this.markdownEditor = new SimpleMDE({
      element: document.getElementById(this.id),
      status: false,
      spellChecker: true,
      toolbar: [
        {
          name: 'bold',
          action: SimpleMDE.toggleBold,
          className: 'fa fa-bold',
          title: 'Bold',
          default: true
        },
        {
          name: 'italic',
          action: SimpleMDE.toggleItalic,
          className: 'fa fa-italic',
          title: 'Italic',
          default: true
        },
        '|',
        {
          name: 'link',
          action: SimpleMDE.drawLink,
          className: 'fa fa-link',
          title: 'Create Link',
          default: true
        },
        '|',
        {
          name: 'preview',
          action: SimpleMDE.togglePreview,
          className: 'fa fa-eye no-disable',
          title: 'Toggle Preview',
          default: true
        },
        '|',
        {
          name: 'guide',
          action: 'https://simplemde.com/markdown-guide',
          className: 'fa fa-question-circle',
          title: 'Markdown Guide',
          default: true
        }
      ]
    });

    this.markdownEditor.value(this.content);

    this.markdownEditor.codemirror.on('change', () => {
      this.content = this.markdownEditor.value();
      this.contentChange.emit(this.content);
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    // If the 'content' value is changed by the parent component, update the
    // markdown editor.
    // We must be careful to only update the editor if the content was changed
    // externally, not due to edits made within the editor itself, because
    // calling .value() with an argument will move the cursor to the start of
    // the input, even if the value does not change.
    if (this.markdownEditor) {
      if (this.markdownEditor.value() !== this.content) {
        this.markdownEditor.value(changes.content.currentValue);
      }
    }
  }

}
